import EE from '@src/common/event';
import Helper from "@src/common/helper/core";
import client360Store from "@public/client/client360";

// 需要在页面间传递的参数
export const DeliveryKeys = {
  src : "src",
};

class Log {
  baseData = {};

  pageLoadEndTime = null; // 页面加载结束时间，page_load_end 时间
  pageInitUrl = ""; // 页面最初打开时的 url
  hasTrackInitPage = true; // monitor 自动 pv，首次 getTrack 不响应

  waitList = [];  // 等待时机打点
  filterList = [];  // 过滤掉下一个满足条件的打点

  constructor () {
    this.pageInitUrl = location.href;

    // 登录时更新 userid
    EE.on("login", (userInfo) => {
      this.updateUserInfo(userInfo);
    });

    this.doAction(() => {
      this.initBaseData();
      this.resetMonitor();
  
      // 热力图 每 1 分钟 10 次 getClickHeatmap(10, 1)
      monitor.getClickHeatmap(10, 1);
  
      if(window._page_load_begin){
        monitor.logOld({
          key : "page_loading",
          action : "page_load_end",
          seg_times : window._page_load_begin ? (+new Date - window._page_load_begin) : '',
          os : this.baseData.os,
          version : Helper.revision?.time || "",
        }, "wpo");
      }
      this.pageLoadEndTime = +new Date;
    })
  }

  // 重写 monitor 方法
  resetMonitor () {
    if (monitor.logOld) return;

    monitor.getTrackOld = monitor.getTrack;
    monitor.logOld = monitor.log;
    monitor.setConf("ssrpUrl", "https://aigc.s.qhupdate.com/chat/srp.gif");
    monitor.setConf("sdispUrl", "https://aigc.s.qhupdate.com/chat/disp.gif");
    monitor.setConf("sclickUrl", "https://aigc.s.qhupdate.com/chat/click.gif");
    monitor.setConf("smoniUrl", "https://aigc.s.qhupdate.com/chat/moni.gif");

    monitor.log = (data = {}, ...props) => {
      data = {
        ...{
          title : document.title,
        },
        ...this.baseData,
        ...data,
      }

      monitor.logOld(data, ...props);
    }
  }

  // 更新用户信息
  updateUserInfo (userInfo) {
    try{
      this.setBaseData({
        user_id : userInfo.id || '',
      });
    } catch(e){}
  }

  setData (key, value) {
    this[key] = value;
  }
  setBaseData (value){
    this.baseData = {
      ...this.baseData,
      ...value,
    }
  }

  initBaseData () {
    this.setBaseData({
      // 用户浏览器
      b : monitor.util.getBrowser(),
      // Flash版本
      fl: monitor.util.getFlashVer(),
      // referrer
      r: monitor.util.getReferrer(),
      // 屏幕颜色
      sd: monitor.util.getColorDepth(),
      // 分辨率
      sr: monitor.util.getScreenSize(),
      // 浏览器语言
      ul: monitor.util.getLanguage(),
      // 是否支持cookie
      ce: monitor.util.getSid() === monitor.util.getSid() ? 1 : 0,

      ...this._getBaseData(),
    });
  }
  _getBaseData () {
    const baseData = {};
    const urlParams = Helper.getParams();

    // 承载平台
    // 承载客户端
    if(Helper.isPhone()){
      baseData.platform = "zhinao_h5";
      baseData.os = Helper.isAndroid() ? 'android' : 'ios';
      if(Helper.isWeixin()){
        baseData.cl = "weixin";
      }
      else if(Helper.is360Browser()){
        baseData.cl = "360se";
      }
    }
    else {
      baseData.platform = "zhinao_web";
      baseData.os = Helper.isMac() ? 'mac' : 'windows';
      if(Helper.is360Browser()){
        baseData.cl = "360se";
      }
    }
    const broswerInfo = Helper.getBrowserNameAndVersion();
    if(!baseData.cl){
      if(broswerInfo.name){
        baseData.cl = broswerInfo.name;
      }
      else {
        baseData.cl = "other";
      }
    }
    baseData.ov = broswerInfo.version;

    Object.keys(DeliveryKeys).forEach(key => {
      if(urlParams[key]){
        baseData[DeliveryKeys[key]] = urlParams[key];
      }
    });
    
    return baseData;
  }

  getTrack (...props) {
    this.doAction(() => {
      if(!monitor.data.getBase().p){
        return;
      }
      if(location.href == this.pageInitUrl){
        if(this.hasTrackInitPage){
          this.hasTrackInitPage = false;
          return;
        }
      }
  
      monitor.getTrack(...props);
    });
  }
  log (params, type) {
    this.doAction(() => {
      if(!monitor.data.getBase().p){
        return;
      }
      if(this.checkFiltered(params)){
        return;
      }
      if(!type && params.action && !/^click/.test(params.action)){
        type = "wpo";
      }
      params.mid = client360Store.getMid();
      params.m2 = client360Store.m2;
      monitor.log(params, type);
    });
  } 
  // 容错，monitor 未加载导致白屏
  doAction (fn = () => {}) {
    if(!window.monitor){
      return;
    }
    fn();
  }

  getRouterName () {
    const pathname = location.pathname;

    return /^\/chat/.test(pathname) ? "aibot_chat"                // 对话页
      : /^\/agreements/.test(pathname) ? "aibot_agreement"         // 协议页
      : pathname == "/" ? "aibot_home"                            // 首页
      : /^\/tools\/aiagent/.test(pathname) ? "aibot_agent"        // MCP 智能体
      : "aibot_other";                                            // 其它
  }

  /**
   * 等待时机打点
   * @param {String} type 
   * @returns 
   */
  wait (type) {
    let resolveDone = null;
    const promiseDone = new Promise((resolve) => {
      resolveDone = resolve;
    });
    this.waitList.push({
      type,
      resolve : resolveDone,
    });
    return promiseDone;
  }
  fire (type) {
    this.waitList.forEach(item => {
      if(item.type == type){
        item.resolve();
      }
    });
    this.waitList = this.waitList.filter(item => item.type != type);
  }

  /**
   * 过滤掉下一个满足条件的打点
   * @param {Object} params 
   */
  filterNext(params){
    this.filterList.push(params);
  }
  resumeNext(params){
    this.filterList = this.filterList.filter(item => {
      return !Object.keys(item).every(key => item[key] == params[key]);
    });
  }
  checkFiltered (params) {
    if(!this.filterList.length){
      return false;
    }
    const index = this.filterList.findIndex(item => {
      return Object.keys(item).every(key => item[key] == params[key]);
    });
    if(index == -1){
      return false;
    }
    this.filterList.splice(index, 1);
    return true;
  }

  /**
   * 截断，避免打点 414
   */
  getSubContent (content, len = 400, tail = '') {
    if(!content){
      return "";
    }
    return Helper.substring(content, len, tail);
  }
}

const appLogger = window._Logger = new Log();
export default appLogger;